import {
  getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatistics,
  getGetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatisticsKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type {
  GetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatistics200,
  GetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatisticsParams,
} from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  threeLetterCode: string;
  id: number;
  scope: GetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatisticsParams['scope'];
  enabled?: boolean;
};

type IUseGetClientNewsletterStatistics = (args: Args) => {
  data: GetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatistics200;
};

/**
 * 社内報統計情報取得フック
 *
 * @param enabled - false の場合はフェッチをスキップする（未公開記事など）
 */
export const useGetClientNewsletterStatistics: IUseGetClientNewsletterStatistics = ({
  threeLetterCode,
  id,
  scope,
  enabled = true,
}) => {
  const { data } = useFetch(
    enabled
      ? getGetApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatisticsKey(
          threeLetterCode,
          id,
          { scope }
        )
      : undefined,
    () =>
      getApiV1ThreeLetterCodeClientAdminsClientNewslettersClientNewsletterIdStatistics(
        threeLetterCode,
        id,
        { scope }
      ),
    { suspense: true }
  );

  if (!data) {
    return {
      data: { client_newsletter_statistics: { read_rate: 0, user_count: 0, read_count: 0 } },
    };
  }

  return { data };
};
